import React from "react";
import "./tailwind.css";
// import { ClearCacheProvider } from "react-clear-cache";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "styled-components";
import { defaultAppTheme } from "./theme/defaultAppTheme";
import * as serviceWorkerRegistration from './serviceWorker'; // Verifique o nome do seu arquivo
const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={defaultAppTheme}>
      {/* <ClearCacheProvider duration={5000}> */}
      <App />
      {/* </ClearCacheProvider> */}
    </ThemeProvider>
  </React.StrictMode>
);

// AQUI ESTÁ A LÓGICA CORRETA.
// Vamos usar a função do seu arquivo serviceWorker.ts e passar o callback onUpdate
serviceWorkerRegistration.register({
  onUpdate: registration => {
    // Quando uma atualização for detectada, avisamos o App.tsx através de um evento
    const event = new CustomEvent('newVersionReady', { detail: registration });
    window.dispatchEvent(event);
  },
});